import PropTypes from "prop-types";
import React from "react";

import BarPreview from "./bar_preview";
import LinePreview from "./line_preview";
import TilePreview from "./tile_preview";

const PlatformUsagePreview = ({ content, animated = false }) => (
  <div>
    <div style={{ display: "flex", marginTop: "1rem" }}>
      <TilePreview />
      <TilePreview />
      <TilePreview />
    </div>
    <div style={{ display: "flex" }}>
      <TilePreview />
      <TilePreview />
      <TilePreview />
    </div>
    <LinePreview animated={animated} content={content} />
    <BarPreview animated={animated} content={content} />
  </div>
);

PlatformUsagePreview.propTypes = {
  content: PropTypes.string,
  animated: PropTypes.bool
};

export default PlatformUsagePreview;
